<div class="component">
  @if (!inEditMode) {
    <div>
      <span>{{ title }}</span>
      <span class="pull-right"
        >{{ value }}
        @if (displayValue) {
          <span>{{ displayValue }}</span>
        }
        @if (canEdit) {
          <i class="mdi mdi-square-edit-outline can-click" (click)="editMode()" title="Edit" tooltipPosition="top"></i>
        }
      </span>
    </div>
  }
  @if (inEditMode) {
    <div>
      <div class="row">
        @if (!propertyType) {
          <div class="col-xs-9 col-sm-10">
            <input class="form-control" [(ngModel)]="value" />
          </div>
        }
        @if (propertyType === 'list') {
          <div class="col-xs-9 col-sm-10">
            <select [(ngModel)]="value">
              // value is a string or number
              @for (obj of propertyList; track obj) {
                <option [value]="obj.id">{{ obj.title }}</option>
              }
            </select>
          </div>
        }
        <div class="col-xs-3 col-sm-2">
          <div class="icons pull-right"><i class="fa fa-check fa-fw" (click)="save()"></i>&nbsp;<i class="fa fa-times fa-fw" (click)="editMode()"></i></div>
        </div>
      </div>
    </div>
  }
</div>
